import styled from 'styled-components';
import Slider from 'react-slick';

export const InPageResourceContainer = styled.div`
  padding: 75px 28px 75px;

  .in-page-resource--wrapper {
    max-width: 1196px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    .in-page-resource--featured-content {
      margin: 0 60px 40px 0;
      @media (max-width: 815px) {
        margin: 0 20px 40px 0;
      }
      .in-page-resource--featured-content-wrapper {
        width: 376px;

        .in-page-resource--featured-item {
          .in-page-resource--featured-item-wrapper {
            height: 460px;
            width: 100%;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
          }
          .in-page-resource--featured-item-content {
            width: 100%;
            height: 100%;
            background: transparent;
            padding: 25px;
            position: relative;
            .in-page-resource--featured-item-body {
              display: none;
            }

            &:hover {
              background: #00000099;
              .in-page-resource--featured-item-body {
                display: block;
              }
              @media (max-width: 575px) {
                background: transparent;
              }
            }
            h3 {
              font-weight: 500;
              line-height: 120%;
              text-align: left;
              color: #ffffff;
              margin: 0;
            }
            p {
              font-size: 20px;
              line-height: 150%;
              color: #ffffff;
              letter-spacing: -0.02em;
              margin: 19px 0 0;
              display: -webkit-box;
              text-overflow: ellipsis;
              overflow: hidden;
              -webkit-line-clamp: 4;
              -webkit-box-orient: vertical;
            }
            .in-page-resource--featured-item-link {
              position: absolute;
              width: calc(100% - 40px);
              margin: 0 auto;
              border: 1px solid #ffffff;
              box-sizing: border-box;
              padding: 15px 0;
              bottom: 30px;
              font-size: 16px;
              font-weight: 600;
              line-height: 120%;
              letter-spacing: -0.02em;
              text-align: center;
              color: #ffffff;
              &:hover {
                background: #ffffff33;
              }
            }
          }
        }
      }
    }
    .in-page-resource--main-content {
      flex: 1;
      .in-page-resource--main-hero {
        padding-bottom: 10px;

        h2 {
          margin-bottom: 10px;
        }
        p {
          font-size: var(--font-size-p-md);
          color: var(--darkest);
        }
      }
      .in-page-resource--navigation-items {
        width: 100%;
        margin-left: -10px;
        .in-page-resource--navigation-items-wrapper {
          display: flex;
          flex-wrap: wrap;
        }
        .in-page-resource--navigation-item {
          padding: 10px;
          width: 33%;
          margin: 10px 0 0 0;
          &:hover {
            background: rgba(16, 13, 19, 0.05);
          }
          .in-page-resource--navigation-item-wrapper {
            display: flex;
            align-items: center;
            width: 240px;
            max-width: 100%;
          }
          .in-page-resource--navigation-icon {
            width: 40px;
            height: 40px;
            min-width: 40px;
            min-height: 40px;
            margin-right: 15px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .in-page-resource--navigation-title {
            color: var(--darkest);
            font-size: var(--font-size-p-md);
            margin: 0;
          }
        }
      }
    }
  }
  @media (max-width: 1061px) {
    .in-page-resource--main-hero {
      h2 {
        max-width: 350px;
      }
    }
  }
  @media (max-width: 1024px) {
    .in-page-resource--wrapper {
      .in-page-resource--main-content {
        .in-page-resource--navigation-items {
          .in-page-resource--navigation-item {
            width: 50%;
          }
        }
      }
    }
  }
  @media (max-width: 767px) {
    padding: 68px 20px;
    .in-page-resource--wrapper {
      flex-direction: column-reverse;
      .in-page-resource--featured-content {
        width: 100%;
        margin: 30px 0 0;
        .in-page-resource--featured-content-wrapper {
          width: 100%;
          max-width: 600px;
          margin: 0 auto;
          .in-page-resource--featured-item {
            .in-page-resource--featured-item-wrapper {
              height: 409px;
              width: 334px;
              margin: 0 auto;
              .styles-container {
                width: inherit;
              }
            }
            .in-page-resource--featured-item-content {
              h3 {
                font-size: 24px;
                line-height: 120%;
              }
            }
          }
        }
      }
      .in-page-resource--main-content {
        width: 100%;
        .in-page-resource--main-hero {
          padding: 0;
          border: none;
          text-align: center;
          h2 {
            font-size: 29px;
            line-height: 120%;
            padding: 0 30px;
            max-width: 100%;
            margin: 0 auto 25px auto;
          }
        }
        .in-page-resource--navigation-items {
          width: calc(100% + 40px);
          margin-left: -20px;
          position: relative;
          &:before,
          &:after {
            content: '';
            position: absolute;
            width: 30px;
            height: 100%;
            top: 0;
          }
          &:before {
            left: 0;
            z-index: 10;
            background: linear-gradient(90deg, #ffffff 20%, rgba(255, 256, 255, 0) 100%);
          }
          &:after {
            right: 0;
            background: linear-gradient(270deg, #ffffff 20%, rgba(255, 256, 255, 0) 100%);
          }
          .in-page-resource--navigation-items-wrapper {
            display: block;
          }
          .in-page-resource--navigation-item {
            margin: 0;
            width: auto;
            .in-page-resource--navigation-item-wrapper {
              width: auto;
              padding: 0 40px 0 0;
            }
          }
        }
      }
    }
  }
  @media (max-width: 575px) {
    padding: 38px 20px 68px 20px;
    .in-page-resource--wrapper {
      .in-page-resource--featured-content {
        .in-page-resource--featured-content-wrapper {
          .in-page-resource--featured-item {
            .in-page-resource--featured-item-content {
              .in-page-resource--featured-item-body {
                display: block;
              }
            }
          }
        }
      }
    }
  }
  @media (max-width: 480px) {
    .in-page-resource--wrapper {
      .in-page-resource--main-content {
        .in-page-resource--main-hero {
          h2 {
            max-width: 300px;
          }
        }
      }
    }
  }
`;

export const FeaturedContentSlider = styled(Slider)`
  height: 460px;
  .slick-dots {
    bottom: -45px;
    button {
      width: 40px;
      height: 40px;
      &:before {
        font-size: 14px;
        color: var(--grey-2);
        opacity: 1;
      }
    }
    .slick-active {
      button {
        &:before {
          color: var(--titan-blue-3);
        }
      }
    }
  }
  @media (max-width: 767px) {
    height: 410px;
  }
`;
